// extracted by mini-css-extract-plugin
export default {"buttonGroups":"AluList_buttonGroups__njvny","li":"AluList_li__xgq-t","link":"AluList_link__7Gu7Q","selected":"AluList_selected__FFjd-"};